<script lang="ts">
    import Fa from 'svelte-fa'
    import { faChartLine, faCoins, faUsers, faCalendarCheck, faArrowRight } from '@fortawesome/free-solid-svg-icons'
    import { Link } from 'yrv'
    import type { ReportCatalogItem } from '../../modules/reportsApi/catalog/report-catalog'
    import Zframe from '../_common/z/zframe.svelte'

    export let reports: ReportCatalogItem[] = []
    export let categories: string[] = []
    export let loading: boolean = false

    const CATEGORY_ICONS: Record<string, any> = {
        Vendas: faCoins,
        Pessoas: faUsers,
        'Agenda e atendimento': faCalendarCheck,
    }
    function categoryIcon(category: string) {
        return CATEGORY_ICONS[category] || faChartLine
    }
</script>

<div class="rv2h">
    {#if loading}
        <div class="rv2h-empty">Carregando relatórios...</div>
    {:else if !reports.length}
        <div class="rv2h-empty">Nenhum relatório disponível no momento.</div>
    {:else}
        <Zframe title="Escolha um relatório" headline="Selecione um item ao lado ou clique em um dos cards abaixo.">
            {#each categories as category}
                {@const items = reports.filter((el) => el.category === category)}
                {#if items.length}
                    <div class="rv2h-section">
                        <div class="rv2h-section_title">
                            <Fa icon={categoryIcon(category)} />
                            <span>{category}</span>
                        </div>
                        <div class="rv2h-grid">
                            {#each items as report}
                                <Link class="rv2h-card" href="/reports-v2/{report.id}">
                                    <div class="rv2h-card_head">
                                        <span class="rv2h-card_label">{report.label}</span>
                                        <Fa icon={faArrowRight} class="rv2h-card_arrow" />
                                    </div>
                                    <div class="rv2h-card_description">{report.description}</div>
                                </Link>
                            {/each}
                        </div>
                    </div>
                {/if}
            {/each}
        </Zframe>
    {/if}
</div>

<style>
    .rv2h {
    }
    .rv2h-empty {
        padding: 64px 16px;
        text-align: center;
        opacity: 0.6;
    }
    .rv2h-intro {
        margin-bottom: 20px;
    }
    .rv2h-intro_title {
        font-size: 24px;
        font-weight: 300;
    }
    .rv2h-intro_subtitle {
        opacity: 0.65;
        font-size: 14px;
        margin-top: 2px;
    }

    .rv2h-section {
        margin-bottom: 24px;
    }
    .rv2h-section_title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        opacity: 0.6;
        margin-bottom: 10px;
    }

    .rv2h-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
        gap: 12px;
    }

    .rv2h :global(a.rv2h-card) {
        display: block;
        border-radius: 10px;
        padding: 14px 16px;
        background: rgba(150, 150, 150, 0.08);
        border: 1px solid rgba(150, 150, 150, 0.14);
        transition:
            border-color 0.12s ease,
            background-color 0.12s ease,
            transform 0.12s ease;
    }
    .rv2h :global(a.rv2h-card:hover) {
        background: rgba(150, 150, 150, 0.14);
        border-color: rgba(var(--menu-color), 0.5);
        transform: translateY(-1px);
    }

    .rv2h-card_head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 6px;
    }
    .rv2h-card_label {
        font-size: 16px;
        font-weight: 600;
    }
    .rv2h :global(.rv2h-card_arrow) {
        opacity: 0.4;
        font-size: 13px;
    }
    .rv2h :global(a.rv2h-card:hover .rv2h-card_arrow) {
        opacity: 1;
        color: rgb(var(--menu-color));
    }

    .rv2h-card_description {
        font-size: 13px;
        opacity: 0.7;
        line-height: 1.4;
    }
</style>
